import React, { useCallback } from 'react';
import { history, useIntl } from 'umi';
import classNames from 'classnames';
import type { IStudioGame } from '@/pages/home/pages/studio/type';
import { LANGUAGE_EN } from '@home/_config/config';
import { selectValByCondition } from '@home/utils/common';
import { getGameRouteCode } from '@/pages/home/pages/studio/utils/prHubSidebarGames';
import { buildSidebarHubGamePath } from '@/pages/home/pages/studio/pr/prHubSubTabs';
import './index.scss';

export interface IStudioPrGamesSidebarProps {
  studioId: string;
  games: IStudioGame[];
  selectedCode?: string;
  /** 侧栏枢纽根路径，如 /pr、/ai */
  hubBasePath?: string;
}

const StudioPrGamesSidebar = (props: IStudioPrGamesSidebarProps) => {
  const { studioId, games, selectedCode, hubBasePath = '/pr' } = props;
  const { locale } = useIntl();

  const handleSelect = useCallback(
    (game: IStudioGame) => {
      const code = getGameRouteCode(game);
      if (!code || !studioId) {
        return;
      }
      // 切换游戏时回到概览 Tab，与整页 key 重挂后的「初始工作台」一致，避免 Tab 高亮与内容错位
      history.push(buildSidebarHubGamePath(studioId, hubBasePath, code));
    },
    [studioId, hubBasePath],
  );

  if (!games?.length) {
    return null;
  }

  return (
    <aside className="dbh-studio-pr-sidebar">
      <div className="dbh-studio-pr-sidebar__list">
        {games.map((game) => {
          const code = getGameRouteCode(game);
          const nameEn = game?.game_name;
          const nameCn = game?.game_name_cn;
          const label = selectValByCondition(locale === LANGUAGE_EN, nameEn, nameCn)?.replaceAll(' ', ' ');
          const isActive = Boolean(selectedCode && code && selectedCode === code);
          return (
            <div
              key={code || `${nameEn}-${nameCn}`}
              className={classNames('dbh-studio-pr-sidebar__item', { 'is-active': isActive })}
              onClick={() => handleSelect(game)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleSelect(game);
                }
              }}
            >
              <div className="dbh-studio-pr-sidebar__thumb">
                <img className="dbh-studio-pr-sidebar__img" src={game?.cover} alt="" />
              </div>
              <div className="dbh-studio-pr-sidebar__name">{label}</div>
            </div>
          );
        })}
      </div>
    </aside>
  );
};

export default StudioPrGamesSidebar;
